export default {
    app: {
        name: 'BZUCO Inspector',
        reseted: 'All tickets reset...',
        networkError: 'Server error, please check network connection and try again...',
        networkNotAvailable: 'No connection'
    },
    menu: {
        test: 'Barcode reader test',
        settings: 'Settings',
        admin: 'Admin',
        resetTickets: 'Reset tickets',
        resetState: 'Reset application',
        logout: 'Logout'
    },
    home: {
        login: 'Login',
        lastEvent: 'Check last selected event / zone',
        lastEvents: 'Check last<br />selected events',
        lastZones: 'Check last<br />selected zones',
        chooseEvent: 'Choose event',
        checkEvents: 'Check<br />events',
        checkZones: 'Check<br />zones',
        scanConfig: 'Scan QR code'
    },
    configScanner: {
        title: 'Configuration QR',
        notConfig: 'Unrecognized configuration code',
        loggedIn: 'Logged in:',
        setsSelected: 'Selected ticketsets:',
        zonesSelected: 'Selected zone:',
        loginRequiredTitle: 'Login required',
        loginRequiredMessage: 'You need to log in before loading ticketsets or zones.',
        counterOn: 'Counter enabled',
        counterOff: 'Counter disabled',
        langSet: 'Language switched',
        scanInfoSet: 'After-scan info mode set',
        ok: 'OK'
    },
    event: {
        chooseEvent: 'Choose event',
        chooseEventPast: 'Past events',
        confirm: 'Confirm event selection',
        showPast: 'show past items'
    },
    zone: {
        chooseZone: 'Select zone(s)',
        confirm: 'Confirm zone selection'
    },
    ticketsets: {
        chooseTicketsets: 'Select ticketsets',
        selectAll: 'Select all',
        ticketCount: 'Ticket count:'
    },
    scanner: {
        tickets: 'Tickets:',
        startReader: 'Start reader',
        startReaderDescription:
            'Browser need interaction with user for playing system sounds for notifications. Confirm please this dialog by pressing "OK" button.',
        specialWarning: 'Warning',
        specialType: 'Ticket of special type:',
        refuse: 'Refuse',
        confirm: 'Confirm',
        messageSuccess: 'Code {code} accepted',
        messageSuccessPrice: 'Code {code} accepted<br /><big>Price: <b>{price}</b></big>',
        messageSuccessTicketsetPrice: 'Code {code} accepted<br /><big>Set: <b>{ticketset} / {price}</b></big>',
        messageSuccessTicketset: 'Code {code} accepted<br /><big>Set: <b>{ticketset}</b></big>',
        messageSuccessEvent: 'Code {code} accepted<br /><big>Event: <b>{event}</b>, Ticketset: {ticketset}</big>',
        messageSuccessNosend: 'Code {code} accepted (not sent)',
        messageRead: 'Code {code} read',
        messageUsed: 'Code {code} already used',
        messageNotUsable: 'Code {code} not usable',
        messageUnsend: 'Code {code} already used (by me, not sent)',
        messageNotFound: 'Code <b>{code}</b> not found',
        messageBadSlot: 'Code {code} not valid for this zone/slot',
        messageExtra1: 'used on device: <b>{device}</b>, date: <b>{date}</b>',
        manualTitle: 'Manual code entry',
        loading: 'loading tickets...',
        nfcNotFound: 'No valid ticket on card'
    },
    login: {
        title: 'Login to mobile app',
        username: 'Username',
        password: 'Password',
        login: 'Login'
    },
    settings: {
        title: 'Settings',
        sound: 'Sound',
        soundSub: 'Enable sound notifications',
        camera: 'Camera',
        nfc_heading: 'NFC',
        nfc: 'Read NFC tags',
        language: 'Language',
        langCs: 'Czech',
        langEn: 'English',
        langDe: 'German',
        langHr: 'Croatian',
        langHu: 'Hungarian',
        langPl: 'Polish',
        langSk: 'Slovak',
        qTitle: 'Advanced camera settings',
        qPatchSize: 'Size of decode window',
        qFrequency: 'Decode frequency',
        groupDisplay: 'Show ticketset / category name in ticket validation',
        groupDisplayNone: 'Show nothing',
        groupDisplayTicketset: 'Show ticketset name',
        groupDisplayTicketsetPrice: 'Show ticketset and price name',
        groupDisplayPrice: 'Show price name',
        groupDisplayEvent: 'Show both event and ticketset name',
        olderEvents: 'How long show older events after expiration',
        olderEventsWeek: 'Week',
        olderEventsMonth: 'Month',
        olderEvents3Month: '3 months',
        olderEvents6Month: '6 months',
        olderEventsYear: '1 year',
        olderEventsAll: 'Show all events',
        olderEventsAllList: 'all events',
        showTicketCount: 'Show ticket count',
        showStatistics: 'Show statistics',
        queueTitle: 'Codes pending in send queue',
        queueSending: 'sending in progress',
        queueYes: 'YES',
        queueNo: 'NO',
        queueEmpty: 'Queue is empty'
    },
    statistics: {
        title: 'Statistics of ticket usage',
        zone: 'Zone',
        today: 'Today',
        total: 'Total',
        refresh: 'Refresh data'
    },
    verify: {
        title: 'Verify ticket',
        enterCode: 'Enter ticket code',
        verify: 'Verify',
        scanHint: 'Scan a code or enter it manually',
        notFound: 'Ticket not found',
        found: 'Ticket found',
        email: 'E-mail',
        entries: 'Entries',
        people: 'People',
        entryPause: 'Entry pause (min)',
        purchased: 'Purchased',
        validUntil: 'Valid until',
        event: 'Event',
        ticketset: 'Ticketset',
        price: 'Price level',
        zones: 'Zones',
        noZones: 'Ticket is not assigned to any zone.',
        slots: 'Slots',
        noSlots: 'Ticket is not assigned to any slot.',
        usageForZone: 'Usage in zone',
        remains: 'Remaining',
        usageLogs: 'Ticket usage log',
        showDebug: 'Q',
        debugQuery: 'Query',
        debugData: 'Data',
        newSearch: 'New verification'
    }
} as const
